module.exports = __webpack_public_path__ + "static/media/52.79e88e7a.jpg";